module.exports = __webpack_public_path__ + "static/media/search-icon.205b3515.svg";